import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import 'react-datepicker/dist/react-datepicker.css';
import './styles/index.scss';
import * as Sentry from '@sentry/react';
import { Integrations as TracingIntegrations } from '@sentry/tracing';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';
import { Auth0Provider } from '@auth0/auth0-react';
import LogRocket from 'logrocket';
import { env } from './env';
import { Routes } from './common/enums/Routes';

const {
  sentry: { dsn, environment, release },
  app: { server },
  auth: { domain, clientId },
  logRocket: { link }
} = env;

Sentry.init({
  dsn,
  environment,
  ignoreErrors: ['Non-Error promise rejection captured'],
  integrations: [new TracingIntegrations.BrowserTracing()],
  tracesSampleRate: 0.25,
  release
});

LogRocket.init(link);

ReactDOM.render(
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    redirectUri={`${window.location.origin}${Routes.Callback}`}
    audience={server}
    useRefreshTokens
    skipRedirectCallback={window.location.pathname !== Routes.Callback}
  >
    <App />
  </Auth0Provider>,
  document.getElementById('root')
);
